/**
 * Cart reservation countdown — bulletproof page-level timer.
 * Loaded once from layout/theme.liquid; survives all cart drawer AJAX swaps.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cartReservationExpiresAt';
  var WINDOW_KEY = '__cartReservationExpiresAt';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatMs(ms) {
    var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return pad(minutes) + ':' + pad(seconds);
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getConfig() {
    var drawer = getDrawer();
    if (!drawer || drawer.dataset.reservationEnabled !== 'true') return null;
    return {
      minutes: parseInt(drawer.dataset.reservationMinutes, 10) || 15,
      message:
        drawer.dataset.reservationMessage ||
        'Your items are reserved for the next $TIME.',
    };
  }

  function hasRealItems() {
    return (
      document.querySelector('#CartDrawer .cart-item:not(.cart-item-protection)') !== null
    );
  }

  function getExpiry() {
    if (window[WINDOW_KEY]) return window[WINDOW_KEY];
    try {
      var stored = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if (Number.isFinite(stored)) {
        window[WINDOW_KEY] = stored;
        return stored;
      }
    } catch (e) {}
    return null;
  }

  function setExpiry(expiry) {
    window[WINDOW_KEY] = expiry;
    try {
      localStorage.setItem(STORAGE_KEY, String(expiry));
    } catch (e) {}
  }

  function clearExpiry() {
    window[WINDOW_KEY] = null;
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function tick() {
    var config = getConfig();
    var root = document.querySelector('[data-cart-reservation-timer]');
    if (!config || !root) return;

    var textEl = root.querySelector('[data-cart-reservation-timer-text]');
    if (!hasRealItems()) {
      root.hidden = true;
      clearExpiry();
      return;
    }

    root.hidden = false;
    var now = Date.now();
    var expiry = getExpiry();

    if (!expiry || expiry <= now) {
      expiry = now + config.minutes * 60 * 1000;
      setExpiry(expiry);
    }

    var remaining = expiry - now;
    var timeHtml =
      '<strong class="cart-reservation-timer__time">' +
      formatMs(remaining) +
      '</strong>';

    if (textEl) {
      textEl.innerHTML = config.message.split('$TIME').join(timeHtml);
    }
  }

  function loop() {
    tick();
    window.setTimeout(loop, 1000);
  }

  window.__cartReservationTick = tick;

  function start() {
    if (window.__cartReservationStarted) {
      tick();
      return;
    }
    window.__cartReservationStarted = true;
    loop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      window.setTimeout(tick, 50);
    });
  }
})();
